/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Loader } from './Loader';
import classNames from 'classnames';

interface BlockingLoaderProps {
  isAbsolute?: boolean;
}
export const BlockingLoader = (props?: BlockingLoaderProps) => {
  const { isAbsolute } = props || {};
  return (
    <div data-testid='blocking-loader' className={classNames({ 'position-absolute': isAbsolute }, 'blocking-loader')}>
      <Loader />
    </div>
  );
};
